import React, { useEffect, useState } from "react";
import "./Notification.css";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router";
import { IconButton } from "@mui/material";
import {
  ArrowForwardIos,
  KeyboardArrowRightOutlined,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import axios from "axios";

export default function NotificationsDashboard() {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const navigate = useNavigate();

  const handleAddTemplateClick = () => {
    navigate("/Templates", { state: { openModal: true } });
  };

  const handleCreateAutomationClick = () => {
    navigate("/AutomatedNotification", { state: { openModal: true } });
  };

  const handleLaunchCampaign = () => {
    navigate("/notificationCampaigns", { state: { openModal: true } });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // template table

  const [templates, setTemplates] = useState({
    templates: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const getTemplates = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-templates`,
        { headers }
      );
      console.log(response.data.data);
      setTemplates(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "Code",
      headerName: "Code",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "Name",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Category",
      headerName: "Category",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Created",
      headerName: "Created By",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.8,
      minWidth: 90,
      renderCell: (params) => {
        const handleNavigate = (event) => {
          event.stopPropagation();
          navigate(`/Templates/${params.row.id}`);
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={handleNavigate}
              color="default"
              style={{ width: "100%" }}
              aria-label="edit"
            >
              <ArrowForwardIos />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const rows = (templates?.templates || [])
    .slice(0, Math.min(4, templates.templates.length))
    .map((template) => ({
      id: template.id,
      Code: template.code,
      Name: template.name,
      Category: template.category?.name,
      Status: template.status,
      Created: template.creator?.name,
      Actions: "",
      rawData: template,
    }));

  const goToTemplates = () => {
    navigate("/Templates");
  };

  // targeting rules table

  const [rules, setRules] = useState({
    data: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const getRules = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/targeting-rules`,
        { headers }
      );
      console.log(response.data.data);
      setRules(response.data.data.targeting_rules);
    } catch (error) {
      console.log(error);
    }
  };

  const rulesColumns = [
    {
      field: "Name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 100,
    },
    {
      field: "Description",
      headerName: "Description",
      flex: 1.2,
      minWidth: 200,
    },
    {
      field: "Criteria",
      headerName: "Criteria",
      flex: 1.2,
      minWidth: 200,
      renderCell: (params) => {
        const criteria = params.row.Criteria;
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                maxHeight: "70px",
                overflowY: "scroll",
                overflowX: "hidden",
                lineHeight: "3.5",
                width: "100%",
              }}
            >
              {criteria.map((c, idx) => {
                const valueDisplay = Array.isArray(c.value)
                  ? `(${c.value.join(", ")})`
                  : c.value;
                return (
                  <div key={idx} style={{ marginBottom: "10px" }}>
                    {c.field} <strong>{c.operator}</strong> {valueDisplay}
                  </div>
                );
              })}
            </div>
          </div>
        );
      },
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Used",
      headerName: "Used In",
      flex: 0.7,
      minWidth: 70,
      renderCell: (params) => {
        const { campaigns, groups } = params.row;
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: "1.8",
              width: "100%",
            }}
          >
            <span>{campaigns} campaigns</span>
            <span>{groups} groups</span>
          </div>
        );
      },
    },
    // {
    //   field: "Actions",
    //   headerName: "Actions",
    //   flex: 0.8,
    //   minWidth: 90,
    //   renderCell: (params) => {
    //     const handleNavigate = (event) => {
    //       event.stopPropagation();
    //       // navigate(`/Templates/${params.row.id}`);
    //     };
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           justifyContent: "center",
    //           alignItems: "center",
    //           height: "100%",
    //           width: "100%",
    //         }}
    //       >
    //         <IconButton
    //           onClick={handleNavigate}
    //           color="default"
    //           style={{ width: "100%" }}
    //           aria-label="edit"
    //         >
    //           <ArrowForwardIos />
    //         </IconButton>
    //       </div>
    //     );
    //   },
    // },
  ];

  const rulesRows = rules.data.slice(0, 4).map((rule) => ({
    id: rule.id,
    Name: rule.name,
    Description: rule.description,
    Criteria: rule.criteria,
    Status: rule.is_active ? "Active" : "Inactive",
    campaigns: rule.campaigns_count,
    groups: rule.user_groups_count,
    Actions: "",
    rawData: rule,
  }));

  //  user groups table

  const [groups, setGroups] = useState({
    data: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const getGroups = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/user-groups`, {
        headers,
      });
      console.log(response.data.data);
      setGroups(response.data.data.user_groups);
    } catch (error) {
      console.log(error);
    }
  };

  const GroupsColumns = [
    {
      field: "Name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 100,
    },
    {
      field: "Description",
      headerName: "Description",
      flex: 1.2,
      minWidth: 200,
    },
    {
      field: "Type",
      headerName: "Type",
      flex: 0.7,
      minWidth: 70,
      renderCell: (params) => {
        const { Type } = params.row;
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: Type === "Dynamic" ? "#3FBEAC1A" : "#F6E9FC",
                width: "65%",
                height: "65%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "10px",
                textAlign: "center",
              }}
            >
              <span>{Type}</span>
            </div>
          </div>
        );
      },
    },
    {
      field: "Users",
      headerName: "Users",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Used",
      headerName: "Used In",
      flex: 0.7,
      minWidth: 70,
      renderCell: (params) => {
        const { campaigns } = params.row;
        return (
          <div>
            <span>{campaigns} campaigns</span>
          </div>
        );
      },
    },
    // {
    //   field: "Actions",
    //   headerName: "Actions",
    //   flex: 0.8,
    //   minWidth: 90,
    //   renderCell: (params) => {
    //     const handleNavigate = (event) => {
    //       event.stopPropagation();
    //       // navigate(`/Templates/${params.row.id}`);
    //     };
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           justifyContent: "center",
    //           alignItems: "center",
    //           height: "100%",
    //           width: "100%",
    //         }}
    //       >
    //         <IconButton
    //           onClick={handleNavigate}
    //           color="default"
    //           style={{ width: "100%" }}
    //           aria-label="edit"
    //         >
    //           <ArrowForwardIos />
    //         </IconButton>
    //       </div>
    //     );
    //   },
    // },
  ];

  const GroupsRows = groups.data.slice(0, 4).map((group) => ({
    id: group.id,
    Name: group.name,
    Description: group.description ? group.description : "undefined",
    Users: group.user_ids == null ? "0" : group.user_ids,
    Type: group?.is_dynamic ? "Dynamic" : "Static",
    campaigns: group.campaign_count,
    Actions: "",
    rawData: group,
  }));

  //  campaigns table

  const [campaigns, setCampaigns] = useState({
    data: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const getCampaigns = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-campaigns`,
        {
          headers,
        }
      );
      console.log(response.data.data);
      setCampaigns(response.data.data.campaigns);
    } catch (error) {
      console.log(error);
    }
  };

  const CampaignsColumns = [
    {
      field: "Name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 100,
    },
    {
      field: "Template",
      headerName: "Template",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Target",
      headerName: "Target",
      flex: 0.7,
      minWidth: 70,
      renderCell: (params) => {
        return <div>{params.row.Target ? params.row.Target : "-"}</div>;
      },
    },
    {
      field: "Channels",
      headerName: "Channels",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => {
        const { Channels } = params.row;

        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "4px",
                maxHeight: "80px",
                overflowY: "auto",
                padding: "25px 8px",
                width: "100%",
              }}
            >
              {Channels.map((channel, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#3FBEAC1A",
                    width: "45%",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "4px 8px",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                    flex: "1 1 0",
                  }}
                >
                  {channel}
                </div>
              ))}
            </div>
          </div>
        );
      },
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Progress",
      headerName: "Progress",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        const progress = params.row.Progress;

        let bgColor = "#ccc";
        if (progress <= 30) bgColor = "#ffeb3b";
        else if (progress <= 70) bgColor = "#3E9FF6";
        else bgColor = "#8CB369";

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <div
              style={{
                height: "10px",
                width: "75%",
                backgroundColor: "#f0f0f0",
                borderRadius: "6px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${progress}%`,
                  height: "100%",
                  backgroundColor: bgColor,
                  transition: "width 0.3s ease",
                }}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "Date",
      headerName: "Start Date",
      flex: 0.7,
      minWidth: 70,
    },
    // {
    //   field: "Actions",
    //   headerName: "Actions",
    //   flex: 0.8,
    //   minWidth: 90,
    //   renderCell: (params) => {
    //     const handleNavigate = (event) => {
    //       event.stopPropagation();
    //       // navigate(`/Templates/${params.row.id}`);
    //     };
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           justifyContent: "center",
    //           alignItems: "center",
    //           height: "100%",
    //           width: "100%",
    //         }}
    //       >
    //         <IconButton
    //           onClick={handleNavigate}
    //           color="default"
    //           style={{ width: "100%" }}
    //           aria-label="edit"
    //         >
    //           <ArrowForwardIos />
    //         </IconButton>
    //       </div>
    //     );
    //   },
    // },
  ];

  const CampaignsRows = campaigns.data.slice(0, 4).map((camp) => ({
    id: camp.id,
    Name: camp.name,
    Template: camp?.template?.name,
    Target: camp?.targeting_rule?.name,
    Status: camp.status,
    Channels: camp.channels,
    Progress: parseFloat(camp.progress),
    Date: formatDate(camp.started_at),
    Actions: "",
    rawData: camp,
  }));

  //  Automated table

  const [automated, setAutomated] = useState({
    data: [],
    current_page: 1,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
  });

  const getAutomated = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/automated-notifications`,
        {
          headers,
        }
      );
      console.log(response.data.data);
      setAutomated(response.data.data.notifications);
    } catch (error) {
      console.log(error);
    }
  };

  const AutomatedColumns = [
    {
      field: "Name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 100,
    },
    {
      field: "Type",
      headerName: "Type",
      flex: 0.9,
      minWidth: 100,
    },
    {
      field: "Schedule",
      headerName: "Schedule",
      flex: 0.9,
      minWidth: 100,
      renderCell: (params) => {
        return <div>{params.row.Schedule ? params.row.Schedule : "-"}</div>;
      },
    },
    {
      field: "Template",
      headerName: "Template",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      minWidth: 70,
    },

    {
      field: "Next",
      headerName: "Next Run",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Recipients",
      headerName: "Recipients",
      flex: 0.7,
      minWidth: 70,
    },
    // {
    //   field: "Actions",
    //   headerName: "Actions",
    //   flex: 0.8,
    //   minWidth: 90,
    //   renderCell: (params) => {
    //     const handleNavigate = (event) => {
    //       event.stopPropagation();
    //       // navigate(`/Templates/${params.row.id}`);
    //     };
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           justifyContent: "center",
    //           alignItems: "center",
    //           height: "100%",
    //           width: "100%",
    //         }}
    //       >
    //         <IconButton
    //           onClick={handleNavigate}
    //           color="default"
    //           style={{ width: "100%" }}
    //           aria-label="edit"
    //         >
    //           <ArrowForwardIos />
    //         </IconButton>
    //       </div>
    //     );
    //   },
    // },
  ];

  const AutomatedsRows = automated.data.slice(0, 4).map((aut) => ({
    id: aut.id,
    Name: aut.name,
    Type: aut.type,
    Template: aut?.template?.name,
    Schedule: aut?.schedule_config,
    Status: aut.is_active === true ? "Active" : "Inactive",
    Recipients: aut.total_recipients,
    Next: formatDate(aut.next_run_at),
    Actions: "",
    rawData: aut,
  }));

  //  effects

  useEffect(() => {
    getTemplates();
    getRules();
    getGroups();
    getCampaigns();
    getAutomated();
  }, []);

  return (
    <>
      <div className="m-4">
        {/* Dashboard  */}
        <div className="notifications-display ">
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">
            Notifications Dashboard
          </p>
        </div>
        {/* Notification analytics  */}
        <div className=" border border-1 rounded-3 p-4 my-3">
          <p className=" fw-semibold fs-5">Notification analytics</p>
          {/* Main Notifications  */}
          <div className=" notifications-display d-flex justify-content-between align-items-center">
            <div className="notif-card w-25 border mx-2 border-1 rounded-3 p-3">
              <p className=" fs-5 fw-semibold text-muted ">Active Campaigns</p>
              <p className=" fs-5 fw-bold">12</p>
            </div>
            <div className="notif-card w-25 border mx-2 border-1 rounded-3 p-3">
              <p className=" fs-5 fw-semibold text-muted ">Automated Flows</p>
              <p className=" fs-5 fw-bold">8</p>
            </div>
            <div className="notif-card w-25 border mx-2 border-1 rounded-3 p-3">
              <p className=" fs-5 fw-semibold text-muted ">Messages Sent</p>
              <p className=" fs-5 fw-bold">24.5K</p>
            </div>
            <div className="notif-card w-25 border mx-2 border-1 rounded-3 p-3">
              <p className=" fs-5 fw-semibold text-muted ">Open Rate</p>
              <p className=" fs-5 fw-bold">68%</p>
            </div>
          </div>
        </div>
        {/* Quick actions */}
        <div className=" border border-1 rounded-3 p-4 my-3">
          <p className=" fw-semibold fs-5">Quick Actions</p>
          {/* Actions */}
          <div className="analytics mt-md-3 notifications-display d-flex justify-content-between align-items-center fw-semibold">
            <div
              style={{ width: "31%" }}
              className=" notific-wtf border border-1 rounded-3 bg-body-secondary mx-2 my-1 notifications-display d-flex justify-content-between align-items-center p-3 cursor"
              onClick={handleAddTemplateClick}
            >
              <p>Add New Template</p>
              <KeyboardArrowRightOutlined />
            </div>
            <div
              style={{ width: "31%" }}
              className=" notific-wtf border border-1 rounded-3 bg-body-secondary mx-2 my-1 notifications-display d-flex justify-content-between align-items-center p-3 cursor"
              onClick={handleLaunchCampaign}
            >
              <p>Launch Campaign </p>
              <KeyboardArrowRightOutlined />
            </div>
            <div
              style={{ width: "31%" }}
              className=" notific-wtf border border-1 rounded-3 bg-body-secondary mx-2 my-1 notifications-display d-flex justify-content-between align-items-center p-3 cursor"
              onClick={handleCreateAutomationClick}
            >
              <p>Create Automation</p>
              <KeyboardArrowRightOutlined />
            </div>
          </div>
        </div>
        {/* Notifications Templates */}
        <div className=" d-flex justify-content-between align-items-center mt-3">
          <p className=" fs-5 fw-semibold">Notification Templates</p>
          <p className=" cursor" onClick={goToTemplates}>
            View all{" "}
            <span>
              <i class="fa-solid fa-angle-right"></i>
            </span>
          </p>
        </div>
        <div className=" notifications-table">
          <Paper sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              hideFooter
              checkboxSelection
              sx={{ border: 0 }}
            />
          </Paper>
        </div>
        {/* Notifications Rules */}
        <div className=" d-flex justify-content-between align-items-center mt-3">
          <p className=" fs-5 fw-semibold">Targeting Rules</p>
          <p className=" cursor" onClick={() => navigate("/targetingRules")}>
            View all{" "}
            <span>
              <i class="fa-solid fa-angle-right"></i>
            </span>
          </p>
        </div>
        <div className=" notifications-table">
          <Paper sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={rulesRows}
              columns={rulesColumns}
              hideFooter
              checkboxSelection
            />
          </Paper>
        </div>
        {/* user groups */}
        <div className=" d-flex justify-content-between align-items-center mt-3">
          <p className=" fs-5 fw-semibold">User Groups</p>
          <p className=" cursor" onClick={() => navigate("/Usergroup")}>
            View all{" "}
            <span>
              <i class="fa-solid fa-angle-right"></i>
            </span>
          </p>
        </div>
        <div className=" notifications-table">
          <Paper sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={GroupsRows}
              columns={GroupsColumns}
              hideFooter
              checkboxSelection
            />
          </Paper>
        </div>
        {/* campaigns */}
        <div className=" d-flex justify-content-between align-items-center mt-3">
          <p className=" fs-5 fw-semibold">Notification Campaigns</p>
          <p
            className=" cursor"
            onClick={() => navigate("/notificationCampaigns")}
          >
            View all{" "}
            <span>
              <i class="fa-solid fa-angle-right"></i>
            </span>
          </p>
        </div>
        <div className=" notifications-table">
          <Paper sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={CampaignsRows}
              columns={CampaignsColumns}
              hideFooter
              checkboxSelection
            />
          </Paper>
        </div>
        {/* Automated */}
        <div className=" d-flex justify-content-between align-items-center mt-3">
          <p className=" fs-5 fw-semibold">Automated Notifications</p>
          <p
            className=" cursor"
            onClick={() => navigate("/AutomatedNotification")}
          >
            View all{" "}
            <span>
              <i class="fa-solid fa-angle-right"></i>
            </span>
          </p>
        </div>
        <div className=" notifications-table">
          <Paper sx={{ height: "100%", width: "100%" }}>
            <DataGrid
              rows={AutomatedsRows}
              columns={AutomatedColumns}
              hideFooter
              checkboxSelection
            />
          </Paper>
        </div>
      </div>
    </>
  );
}
